import { Stack, Typography, Link } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const questionStyle = {
    padding:2,
    fontWight: "bold",
    verticalAlign: 'middle',
   // display: 'flex',
    alignItems: 'center',
   // flexWrap: 'wrap',
}
const linkStyle = {
    ml:1,
    color:"blue"

}
const iconStyle = {
    ml:1, 
    mr:1, 
    verticalAlign: "middle"
}

export default function FaqContactUs()
{
    return <Stack sx={{padding:5}}>
        <Typography variant="h5">General Enquiries</Typography>
        <Typography variant="body1" sx={questionStyle}>
        Email: enquiries@knowledgequity.com.au

Available during business hours (Melbourne) and monitored out of hours.
        </Typography>
        <Typography variant="h5">Subject Matter Queries</Typography>
        <Typography variant="body1" sx={questionStyle}>Ask-the-Expert online <span><Link sx={linkStyle} href="https://knowledgequity.com.au/forums/">forum </Link></span><OpenInNewIcon sx={iconStyle}/> (logged in users only)</Typography>
        <Typography variant="body1" sx={questionStyle}>Available during the CPA Program semester.</Typography>
        <Typography variant="h5">Frequently Asked Questions (FAQs):</Typography>
        
        <Typography variant="body1" sx={questionStyle}>
            1. Facebook groups for S2, 2026 are open. The links are below:
        </Typography>
        <ul>
<li><a href="https://www.facebook.com/groups/542160082565785" target="_blank" rel="noopener">Ethics &amp; Governance</a></li>
<li><a href="https://www.facebook.com/groups/633860550057616" target="_blank" rel="noopener">Financial Reporting</a></li>
<li><a href="https://www.facebook.com/groups/154626024894411" target="_blank" rel="noopener">Global Strategy &amp; Leadership</a></li>
<li><a href="https://www.facebook.com/groups/523267211164579" target="_blank" rel="noopener">Strategic Management Accounting</a></li>
<li><a href="https://www.facebook.com/groups/1513209895642717" target="_blank" rel="noopener">Advanced Audit &amp; Assurance</a></li>
<li><a href="https://www.facebook.com/groups/239662652883902" target="_blank" rel="noopener">Tax (Australia Taxation &amp; Australia Taxation – Advanced)</a></li>
<li><a href="https://www.facebook.com/groups/662788133771273" target="_blank" rel="noopener">Contemporary Business Issues</a></li>
<li><a href="https://www.facebook.com/groups/3113626095536413" target="_blank" rel="noopener">Digital Finance</a></li>
<li><a href="https://www.facebook.com/groups/474315322766027" target="_blank" rel="noopener">Financial Risk Management</a></li>
</ul>
       
        <Typography variant="body1" sx={questionStyle} >
        2. In the break between semesters, you can enrol in ourfree Assist courses to help with your subject selection and get a start on your studies. Go to <span><Link sx={linkStyle} href="https://knowledgequity.com.au">https://knowledgequity.com.au</Link></span><OpenInNewIcon sx={iconStyle}/>and choose your subject then sign up.
        </Typography>
        <Typography variant="body1" sx={questionStyle}>
        3. Calculators – You can use a financial, scientific, or standard calculator with no programmable functions, storage capabilities or internet connectivity.
        </Typography>
        <Typography variant="body1" sx={questionStyle}>
        4. Foundation exams – Yes, we currently offer support for the Financial Accounting and Reporting (FAR) foundation exam only. However, you may find our free Assist courses useful for some topic areas, as well as our <span><Link sx={linkStyle} target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/KnowledgEquity">YouTube channel</Link></span><OpenInNewIcon sx={iconStyle}/> for a range of short video tutorials.
        </Typography>
        <Typography variant="body1" sx={questionStyle}>
        5. Where can I get past exam papers? CPA Australia does not provide past exam papers and, as a result, KnowledgEquity does not have any past exam papers. KnowledgEquity provides two full-length practice exams as well as a range of tests and quizzes, which will be more than enough to prepare you for your exam.
        </Typography>
        <Typography variant="body1" sx={questionStyle}>
         In all cases, we aim to respond within 2 business days.
        </Typography>
    </Stack>
}
